type Window = any

export const getWindow = (defaultValues: any): Window =>
    typeof window === 'undefined' ? (defaultValues as Window) : window
